// this file added by Bearer Web Developer
import React, { useEffect, useRef, useState } from 'react';
import styles from './listedTabs.module.scss';
import { IOrderState, SearchRiderEnum, useAppState } from '../../states/app-state';
import { Button } from '@mui/material';
import { useThemeMode } from '../../states/contexts/theme';
import { observer } from 'mobx-react-lite';
import Situation from './situation';
import noAttentionsFunction from './noAttentionsFunction';
import NoOrder from './noOrder';

interface Props {
    handleAddNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<boolean | undefined>
    handleSelect: (event: React.ChangeEvent<{}>, value: number) => void
}

const ListedTabs: React.FC<Props> = observer(({ handleAddNew, handleSelect }) => {

    const appState = useAppState();
    const { theme } = useThemeMode();
    const content = useRef<HTMLDivElement>(null);
    const [allJobs, setAllJobs] = useState<boolean>(true);
    const [lastSelectedMustBeShown, setLastSelectedMustBeShown] = useState<boolean>(true);
    const scrollToEnd = () => {
        if (content?.current) {
            content?.current.scrollTo({
                top: content?.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    }
    const toggleAllJobs = (value?: boolean) => {
        // manage to dont show selected item when items were in alljobs (all orders) and they must switch in notification mode
        // and manage to show selected item when items are only in notification mode or alljobs (all orders) and there is no switching 
        if (value) {
            if (!allJobs) setAllJobs(true);
            if (!lastSelectedMustBeShown) setLastSelectedMustBeShown(true);
        } else {

            const order = appState?.selectedOrder;
            const step = order?.transport?.step;
            const searchRiderChanged = order?.searchRider?.changeData;
            const noAttentions = step && searchRiderChanged && noAttentionsFunction(step);
            // if slected Item from all jobs was true and the mode must be notification, the Last Selected Must BeShown in notification mode
            if ((!noAttentions && (order?.chat?.changeData || order?.searchRider?.changeData))) { 
                setLastSelectedMustBeShown(true);
            } else {
                setLastSelectedMustBeShown(!allJobs);
            }
            setAllJobs(prev => !prev);
        }
    }
    const handleAdd = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        toggleAllJobs(true);
        const result = await handleAddNew(event);
        if (result) scrollToEnd();
    }
    const handleSelection = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
        if (!allJobs) setLastSelectedMustBeShown(true);
        handleSelect(event, i);
    }
    const changedOrdersCount = appState.orders.filter(order => {
        const step = order?.transport?.step;
        const searchRiderChanged = order?.searchRider?.changeData;
        const noAttentions = searchRiderChanged && noAttentionsFunction(step);
        if (noAttentions) return false;
        return (order.chat?.changeData || order?.searchRider?.changeData)
    }).length;
    useEffect(() => {
        scrollToEnd();
    }, []);
    const closeOrder = async (event: React.MouseEvent<HTMLDivElement>, order: IOrderState, index: number) => {
        const closable = !order?.transport.riderInfo;
        event.stopPropagation();
        if (closable) {
            // await order?.transport?.removeMyOrder();
            await order?.transport?.closeOrder(index);
        };
    }
    return (
        <div className={styles.listed_tabs} data-theme={theme}>
            <div className={styles.add_order} >
                <Button className={styles.add_order_button} onClick={(event) => handleAdd(event)}>
                    <div className={styles.plus}>
                        <img src={theme === 'dark' ? "/plus-black.svg" : "/plus-blue.svg"} alt="+" width={22} height={22} />
                    </div>
                    <span>Add Order</span>
                </Button>
                <div className={styles.extra_items}>
                    <Button className={`${styles.all_jobs} ${allJobs ? styles.all_jobs_selected : ''}`} onClick={() => toggleAllJobs()}>
                        <img src="/filter-all.svg" alt="all" width={18} height={18} />
                        {allJobs && <span>All Jobs</span>}
                    </Button>
                    <Button className={`${styles.notification} ${!allJobs ? styles.notification_selected : ''}`} onClick={() => toggleAllJobs()}>
                        <img src={theme === 'dark' ? "/notification-white.svg" : "/notification-blue.svg"} alt="all" width={10.05} height={13.79} />
                        {!allJobs && <span className={styles.attention}>Needs Attention</span>}
                        {changedOrdersCount > 0 && <span className={styles.count}>{changedOrdersCount}</span>}
                    </Button>
                </div>
            </div>
            <hr />
            <div ref={content} className={styles.orders_part}>
                <div className={styles.orders}>
                    {(changedOrdersCount === 0 && !allJobs && !lastSelectedMustBeShown) ? <NoOrder /> : appState.orders.map((order, i) => {
                        const ReservedTab = order?.selectedReservedOrder; // added by Bearer Web Developer
                        const clientOrderNumber = order?.clientOrderNumber; // added by Bearer Web Developer
                        const closable = !order?.transport.riderInfo && order?.searchRider?.step !== SearchRiderEnum.Searching;
                        const selected = appState?.selectedOrderIndex === i;
                        const searchRiderChanged = order?.searchRider?.changeData;
                        const chatChanged = order?.chat?.changeData;
                        const step = order?.transport?.step;
                        const noAttentions = searchRiderChanged && noAttentionsFunction(step);
                        if (!selected && !allJobs && (!chatChanged && !searchRiderChanged)) return null;
                        if (selected && !lastSelectedMustBeShown && (!chatChanged && !searchRiderChanged)) return null;
                        if (!allJobs && noAttentions) return null;
                        return (<Button key={i} className={`${styles.order} ${selected ? styles.selected_order : searchRiderChanged ? styles.search_rider_changed : chatChanged ? styles.chat_changed : ''}`} onClick={(event) => handleSelection(event, i)}>
                            <div className={styles.order_button}>
                                <div>
                                    {ReservedTab ? `Order #: ${ReservedTab?.client_order_number}` : clientOrderNumber ? `Order #: ${clientOrderNumber}` : ('Order ' + (i + 1))}
                                </div>
                                <div className={styles.extra_items}>
                                    {<Situation order={order} />}
                                    {
                                        closable &&
                                        <img className={styles.close_clear}
                                            src={theme === "dark" ? `/close-clear-dark-black.svg` : `/close-clear-dark-blue.svg`}
                                            alt="" width={20} height={20}
                                            onClick={(event) => closeOrder(event, order, i)}
                                        />
                                    }
                                </div>
                            </div>
                        </Button>)

                    })}
                </div>
            </div>
            <div className={styles.shadow}></div>
        </div>
    );
});

export default ListedTabs;
